import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import EventTeaser from './Teaser';
import EventPage from './Page';
import { NodeEvent } from '../../../types/uncinc_profile/nodes';

type EventViewMode = 'teaser';

interface NodeEventProps {
  entity: ImmutableEntity<NodeEvent>;
  viewMode: EventViewMode;
  classes: string;
}

const NodeEventWrapper: React.FC<NodeEventProps> = ({ entity, viewMode, ...props }) => {
  switch (viewMode) {
    case 'teaser':
      return <EventTeaser entity={entity} {...props} />;
    default:
      return <EventPage entity={entity} {...props} />;
  }
};

export default NodeEventWrapper;
